export const API_AUTH_BASE_PATH = '/api/auth'
export const API_AUTH_SIGNIN = 'signin'
export const API_AUTH_LOGOUT = 'logout'
export const API_AUTH_2FA = '2fa'
export const API_AUTH_2FA_CONFIRM = '2fa/confirm'
